export const formatoImporte = (importe) => {
    if (isNaN(importe) || importe === undefined || importe === null) {
        return '0.00';
    }
    return new Intl.NumberFormat('es-PE', {currency: 'PEN', style: 'currency'}).format(importe).replace("S/","").trim()
}

export const porcentajeDescuentoEntero2Precios = (precioMayor, precioMenor) => {
    const porcentajeDescuento = (precioMayor - precioMenor) / precioMayor;
    return parseInt(porcentajeDescuento * 100);
}
